// extracted by mini-css-extract-plugin
module.exports = {"dummyMobile":"_1NseJ"};